// Lot 760 — p95 / max des échantillons de latence (24 h) ; null si moins de 2 mesures. Une décimale sous 10 ms.
export const latencyStats = (values) => {
  const v = (values || []).map(Number).filter((x) => Number.isFinite(x)).sort((a, b) => a - b);
  if (v.length < 2) return null;
  const p95 = v[Math.min(v.length - 1, Math.max(0, Math.ceil(v.length * 0.95) - 1))];
  const fmt = (x) => (x < 10 ? Math.round(x * 10) / 10 : Math.round(x));
  return { p95: fmt(p95), max: fmt(v[v.length - 1]), n: v.length };
};

// Axe ancré : part de 0, monte au moins à 100 ms, arrondi au multiple de 50 au-dessus du max (+15 %).
export const latencyDomainMax = (stats) => (stats ? Math.max(100, Math.ceil((stats.max * 1.15) / 50) * 50) : 100);
